export default __webpack_public_path__ + "static/media/sliderdoce.9da31418.jpg";